
















import Vue from 'vue';
import Component from 'vue-class-component';

const CustomButtonProps = Vue.extend({
  props: {
    text: String,
    link: String,
    linkTarget: String,
    buttonTheme: {
      type: String,
      default: 'default',
    },
  },
});

@Component
export default class CustomButton extends CustomButtonProps {
  get buttonClasses () {
    return {
      'brandhub-custom-button--button': !this.link,
      'brandhub-custom-button--link': this.link,
      'brandhub-custom-button--theme-default': this.buttonTheme === 'default',
      'brandhub-custom-button--theme-framed': this.buttonTheme === 'framed',
      'brandhub-custom-button--theme-elliptic': this.buttonTheme === 'elliptic',
      'brandhub-custom-button--theme-linkout': this.buttonTheme === 'linkout',
      'brandhub-custom-button--theme-textlink': this.buttonTheme === 'textlink',
    };
  }
}
